import { OdataManager } from '@/api/odata/odata-manager';
import { RegisterIssueStatus } from '@/api/model/interfaces';

export default class RegisterIssueStatusOdata extends OdataManager<RegisterIssueStatus> {}
